import { createFileRoute } from '@tanstack/react-router';
import { prefetchInbox } from '@/features/inbox/api';
import { InboxPage } from '@/features/inbox/pages/InboxPage';

export const Route = createFileRoute('/_authed/ops/inbox')({
  staticData: { help: 'inbox' },
  loader: ({ context: { queryClient } }) => prefetchInbox(queryClient),
  component: InboxPage,
});
